// Integrações de terceiros — IDs públicos e código avançado (sem chaves secretas).
// Injetados na página real (ver lib/integrations.js) — isto funciona de verdade,
// não é só visual, porque não exige nenhum segredo de servidor.

export const initialIntegrations = {
  googleAnalyticsId: "",
  googleAdsId: "",
  searchConsoleVerification: "",
  recaptchaSiteKey: "",
  cookiebotId: "",
  mailchimpFormUrl: "",
  activeCampaignFormUrl: "",
  leadloversWebhookUrl: "",
  genericWebhookUrl: "",
  headerCode: "",
  bodyCode: "",
  footerCode: "",
};
